module.exports = __webpack_public_path__ + "img/tuurro.t6.p.2152f48a.png";